module.exports = __webpack_public_path__ + "static/media/apple.7e3671a3.svg";